export default "__VITE_ASSET__dd62fdcb__"